import { render, staticRenderFns } from "./demo_requests_table.vue?vue&type=template&id=de2cc1ba&scoped=true&"
import script from "./demo_requests_table.vue?vue&type=script&lang=js&"
export * from "./demo_requests_table.vue?vue&type=script&lang=js&"
import style0 from "./demo_requests_table.vue?vue&type=style&index=0&id=de2cc1ba&prod&lang=css&"
import style1 from "./demo_requests_table.vue?vue&type=style&index=1&id=de2cc1ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2cc1ba",
  null
  
)

export default component.exports